<section @slideDown class="banner account-creation-banner">
    <div class="banner-message">
        @if (isAccountCreatedByWeChat) {
            <p
                data-cs-mask
                class="banner-message-text"
                i18n="@@hermes-global-translations.your-account-has-been-created-info-banner-wechat">
                {{ prefix }} {{ firstname }} {{ lastname }} welcome to Hermes.com! Your account has been successfully
                created and linked to your WeChat account.
            </p>
        } @else {
            <p data-cs-mask class="banner-message-text">
                {{
                    "hermes-global-translations.your-account-has-been-created-info-banner-angular"
                        | translate: { prefix: prefix, firstname: firstname, lastname: lastname }
                }}</p
            >
        }
    </div>

    <h-close-button class="close-icon" (click)="close()" (keypress.enter)="close()"></h-close-button>
</section>
